import type { PatchRequestType } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/post-patch-request-by-id/post-patch-request-by-id.types'
import type {
  NormalisedRequest,
  RequestStatus,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests.types'
import type { OrderBy } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/requests/requests'

import type { MissionFilterType } from '../../../pages/admin/content/sub-sections/missions/constants'

export const moduleName = 'missions'

export type MissionsState = {
  autoEnrollUser: boolean
  draftRequest: NormalisedRequest | null
  numberOfMissionsConfig: Record<RequestStatus, number | null>
  orderBy: OrderBy
  patchRequestType: PatchRequestType | null
  searchQuery: string
  selectedRequest: NormalisedRequest | null
  selectedStatusOption: RequestStatus
  shouldShowBeneficiaryIndicator: boolean
  showRejectionScreen: boolean
  activeMissionType: MissionFilterType
}
